import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import {
  type CertificateProgramEnrollments,
  type GetCertificateProgramEnrollmentsData,
  CertificateProgramEnrollmentService,
} from '@mc/api'
import { CERTIFICATE_ENROLLMENTS } from './constants'

export const useCertificateEnrollments = (
  options: GetCertificateProgramEnrollmentsData,
  queryOptions?: Omit<
    UseQueryOptions<CertificateProgramEnrollments>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery<CertificateProgramEnrollments>({
    queryKey: [CERTIFICATE_ENROLLMENTS, options],
    queryFn: () =>
      CertificateProgramEnrollmentService.getCertificateProgramEnrollments(
        options,
      ),
    ...queryOptions,
  })
